import { HiArrowNarrowRight } from "react-icons/hi";
import { Link } from "react-scroll";
import { ReactTyped } from "react-typed";

const Home = () => {
  return (
    <div
      name="home"
      className="w-full min-h-screen bg-[#0a192f] flex items-center"
    >
      <div className="max-w-[1200px] w-full mx-auto px-8 py-20 pt-32">
        <div className="space-y-6">
          <div className="inline-block">
            <p className="text-cyan-500 font-semibold text-lg tracking-wide">
              Hi there, I am
            </p>
          </div>

          <h1 className="text-5xl sm:text-7xl lg:text-8xl font-bold text-[#ccd6f6] leading-tight">
            Beki Diribsa
          </h1>

          <div className="h-24 sm:h-32 w-full">
            <h2 className="text-3xl sm:text-5xl lg:text-6xl font-bold text-[#8892b0] w-full">
              <ReactTyped
                strings={[
                  "Senior Full Stack Developer",
                  "Clean Code. Predictable Delivery.",
                  "I Ship On Time. Every Time.",
                  "Lead Engineer for National-Scale Systems",
                  "Multi Award-Winning Computer Engineer",
                ]}
                typeSpeed={0.9}
                backSpeed={80}
                backDelay={10}
                loop
              />
            </h2>
          </div>

          <p className="text-[#8892b0] text-lg sm:text-xl max-w-[800px] leading-relaxed">
            Senior Full-Stack Developer specializing in{" "}
            <span className="text-cyan-500 font-semibold">React</span>,{" "}
            <span className="text-cyan-500 font-semibold">Node.js</span>, and{" "}
            <span className="text-cyan-500 font-semibold">GraphQL</span>. Known
            for obsessive attention to clean code, system reliability, and
            strict on-time delivery. Currently leading development for
            national-level platforms in Ethiopia.
          </p>

          <div className="flex flex-wrap gap-3 text-sm sm:text-base pt-2">
            <span className="px-4 py-2 bg-cyan-600 bg-opacity-20 text-cyan-400 rounded-lg border border-cyan-600 border-opacity-30">
              React & Next.js
            </span>
            <span className="px-4 py-2 bg-cyan-600 bg-opacity-20 text-cyan-400 rounded-lg border border-cyan-600 border-opacity-30">
              Node.js (Express & NestJS)
            </span>
            <span className="px-4 py-2 bg-cyan-600 bg-opacity-20 text-cyan-400 rounded-lg border border-cyan-600 border-opacity-30">
              GraphQL (Hasura)
            </span>
            <span className="px-4 py-2 bg-cyan-600 bg-opacity-20 text-cyan-400 rounded-lg border border-cyan-600 border-opacity-30">
              PostgreSQL
            </span>
          </div>

          <div className="flex flex-wrap gap-4 pt-6">
            <Link to="featured" smooth={true} duration={500}>
              <button className="group rounded-lg text-white border-2 border-cyan-600 px-8 py-4 flex items-center gap-3 hover:bg-cyan-600 hover:shadow-lg hover:shadow-cyan-600/50 transition-all duration-300 font-semibold">
                View My Work
                <span className="group-hover:translate-x-1 transition-transform duration-300">
                  <HiArrowNarrowRight className="text-2xl" />
                </span>
              </button>
            </Link>

            <Link to="contact" smooth={true} duration={500}>
              <button className="rounded-lg text-cyan-400 border-2 border-cyan-600 border-opacity-50 px-8 py-4 hover:bg-[#0a192f] hover:border-cyan-600 transition-all duration-300 font-semibold">
                Get In Touch
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
